import { useFetchAllQueries } from '@/hooks/useFetchAllQueries';

import { BarChart } from './barChart';
import { BarChartVariant, CardVariantProps } from '../../types';
import { mapBarChartData } from '../../utils/mappers';
import { CardWrapper } from '../cardWrapper';
import { BarChartLoader } from './barChartLoader';

interface AdditionalProps {
  variantProps: BarChartVariant;
}

export const BarChartCard = ({
  clearFilters,
  columnFormatter,
  description,
  query,
  sx,
  title,
  variantProps,
}: CardVariantProps & AdditionalProps) => {
  const queryResult = useFetchAllQueries(query);

  return (
    <CardWrapper
      clearFilters={clearFilters}
      description={description}
      query={query.baseQuery}
      queryResult={queryResult}
      renderContent={(successfulResult) => {
        const mappedData = mapBarChartData(successfulResult.data, columnFormatter);

        return <BarChart data={mappedData} entryLabel={variantProps?.entryLabel} />;
      }}
      renderLoading={() => <BarChartLoader />}
      sx={sx}
      title={title}
    />
  );
};
